export default __webpack_public_path__ + "img/5cabfa91a6d8650486e22837042f1f7f.svg";